/* ==========================================================================
   AJ FITS — Instagram coverflow
   Tracks which card is centred, applies depth states, lazy-loads and plays
   only the active video. Nothing downloads until the section is near view.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function initIG(root) {
    $$('[data-aj-ig]', root).forEach(function (section) {
      if (section.dataset.ajIgReady) return;
      section.dataset.ajIgReady = '1';

      var cards = $$('[data-aj-ig-card]', section);
      var dots = $$('[data-aj-ig-dot]', section);
      var prev = $('[data-aj-ig-prev]', section);
      var next = $('[data-aj-ig-next]', section);
      if (!cards.length) return;

      var index = Math.floor(cards.length / 2);

      function apply() {
        cards.forEach(function (card, i) {
          var d = i - index;
          card.dataset.pos = Math.abs(d) > 2 ? 'far' : String(d);
          card.setAttribute('aria-hidden', Math.abs(d) > 2 ? 'true' : 'false');
        });

        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        if (prev) prev.disabled = false;
        if (next) next.disabled = false;

        playActiveOnly();
      }

      function go(n) {
        index = Math.max(0, Math.min(cards.length - 1, n));
        apply();
      }

      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });

      // Clicking a side card brings it to the centre
      cards.forEach(function (card, i) {
        card.addEventListener('click', function (e) {
          if (i === index) return;
          // Let real links and buttons through
          if (e.target.closest('a, button')) return;
          e.preventDefault();
          go(i);
        });
      });

      // Keyboard
      section.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      });

      // Swipe
      var startX = 0, startY = 0;
      section.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });
      section.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(index + (dx < 0 ? 1 : -1));
      }, { passive: true });

      /* ---- Video handling --------------------------------------------- */
      function loadVideo(card) {
        var v = $('video', card);
        if (!v || v.dataset.ajLoaded) return v;
        v.dataset.ajLoaded = '1';
        v.muted = true;
        v.setAttribute('playsinline', '');
        v.preload = 'metadata';
        v.load();
        return v;
      }

      function playActiveOnly() {
        cards.forEach(function (card, i) {
          var v = $('video', card);
          if (!v) return;
          if (i === index) {
            if (reduceMotion || saveData) return;
            loadVideo(card);
            var p = v.play();
            if (p && p.catch) p.catch(function () { card.classList.remove('is-playing'); });
          } else if (!v.paused) {
            v.pause();
          }
        });
      }

      cards.forEach(function (card) {
        var v = $('video', card);
        if (!v) return;
        v.addEventListener('play', function () { card.classList.add('is-playing'); });
        v.addEventListener('pause', function () { card.classList.remove('is-playing'); });

        var btn = $('[data-aj-reel-play]', card);
        if (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            loadVideo(card);
            if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            else v.pause();
          });
        }
      });

      // Nothing loads or plays until the section is actually near the viewport
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) {
                cards.forEach(function (c) { var v = $('video', c); if (v && !v.paused) v.pause(); });
                return;
              }
              loadVideo(cards[index]);
              playActiveOnly();
            });
          },
          { rootMargin: '200px', threshold: 0.25 }
        );
        io.observe(section);
      }

      apply();
    });
  }

  function boot() { initIG(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { initIG(e.target); });
})();
